import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../../useAppTheme";
import { AppIcon } from "../../AppIcon";
import Box from "../../Box";

export const ChangeLabel = () => {
	const theme = useAppTheme();
	const { t } = useTranslation();
	return (
		<Box
			flexDirection="row"
			alignItems="center"
			justifyContent="center"
			gap={4}
		>
			<AppIcon
				name="check-circle-outline"
				size={18}
				color={theme.colors.onBackground}
			/>
			<Text
				variant="bodyMedium"
				style={{ fontStyle: "italic", color: theme.colors.onBackground }}
			>
				{t("onboarding.common.changeLater")}
			</Text>
		</Box>
	);
};
